import type { SchoolbellEStaffWebEnvironment } from './environment.type';

export const environment: SchoolbellEStaffWebEnvironment = {
  production: true,
  apiBaseUrl: 'https://sbe-api-staging.schoolbell-e.com',
  // 로컬 테스트 계정 픽스처는 staging 번들에도 포함하지 않는다(environment.production.ts와 동일 사유).
  testAccounts: [],
};
